var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { UserProfileDto } from '../../user/index.js';
import { CustomFormElementAnswerResponseDto } from './custom-form-element-answer.response.dto.js';
import { CustomFormResponseDto } from './custom-form.response.dto.js';
/**
 * Response DTO for CustomFormAnswer queries.
 * This is independent of the Domain Entity and optimized for the view.
 *
 * @remarks
 * Use this DTO instead of `CustomFormAnswerFullSizeDto` or `CustomFormAnswer` entity.
 * Those are deprecated in favor of dedicated Response DTOs.
 */
export class CustomFormAnswerResponseDto {
    id;
    createdAt;
    updatedAt;
    customFormId;
    userId;
    updatedById;
    updatedBy;
    user;
    customForm;
    customFormElementAnswers;
    get customFormOfficeId() {
        return this.customForm ? this.customForm.officeId : null;
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormAnswerResponseDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormAnswerResponseDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], CustomFormAnswerResponseDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormAnswerResponseDto.prototype, "customFormId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormAnswerResponseDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CustomFormAnswerResponseDto.prototype, "updatedById", void 0);
__decorate([
    Expose(),
    Type(() => UserProfileDto),
    __metadata("design:type", UserProfileDto)
], CustomFormAnswerResponseDto.prototype, "updatedBy", void 0);
__decorate([
    Expose(),
    Type(() => UserProfileDto),
    __metadata("design:type", UserProfileDto)
], CustomFormAnswerResponseDto.prototype, "user", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormResponseDto),
    __metadata("design:type", CustomFormResponseDto)
], CustomFormAnswerResponseDto.prototype, "customForm", void 0);
__decorate([
    Expose(),
    Type(() => CustomFormElementAnswerResponseDto),
    __metadata("design:type", Array)
], CustomFormAnswerResponseDto.prototype, "customFormElementAnswers", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], CustomFormAnswerResponseDto.prototype, "customFormOfficeId", null);
//# sourceMappingURL=custom-form-answer.response.dto.js.map